import { GlobalStyles } from '@mui/material'
import { ReCaptchaProvider } from 'next-recaptcha-v3'
import { useIsRecaptchaEnabled } from '@dtx-company/inter-app/src/hooks/useIsRecaptchaEnabled'
import React from 'react'

const recaptchaBadgeStyles = ` 
  .grecaptcha-badge {
    visibility: hidden;
  }
`
/**
 * Google recommends placing this Provider as high up as possible in the component tree to
 * only load it once and to have recaptcha watch as many interactions by users and bots as
 * possible to better tell them apart.
 */
export const RecaptchaProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const isRecaptchaEnabled = useIsRecaptchaEnabled()

  if (isRecaptchaEnabled) {
    return (
      <>
        <GlobalStyles styles={recaptchaBadgeStyles} />
        <ReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
          {children}
        </ReCaptchaProvider>
      </>
    )
  }

  return children
}
//
